@let vm = viewModel$ | async;

<!-- Templates -->
<ng-template #chatTitleTemplate>
  <div class="d-flex align-items-center fw-bold">
    <kendo-avatar
      class="me-2"
      size="medium"
      imageSrc="https://kehe-connect.s3.amazonaws.com/prod/public_common/chat-icon.png"
    ></kendo-avatar>
    Goodness Guru™

    <!-- no need for close icon -->
    @if (!modalOpen) {
      <i class="fas fa-times close-icon" (click)="anchor.toggle()"></i>
    }
  </div>
</ng-template>

<ng-template #chatBodyTemplate>
  @if (vm.isFeedbackFormOpen) {
    <div class="popover-body k-chat">
      <app-feedback-form
        (cancelForm)="cancelFeedbackForm()"
        (submitForm)="submitFeedbackForm($event)"
      ></app-feedback-form>
    </div>
  } @else {
    <kendo-chat
      class="popover-body"
      [enableFileSelect]="false"
      [enableSpeechToText]="false"
      [messages]="vm.messages"
      [authorId]="vm.user.id"
      (sendMessage)="addUserMessage($event)"
      (executeAction)="onCustomSuggestedAction($event)"
      (focusin)="onChatTextboxFocus($event)"
    >
      <ng-template kendoChatMessageContentTemplate let-message>
        <div>{{ message.text }}</div>
        @if (message.links) {
          <div class="mt-3 mb-3">
            <ul>
              @for (link of message.links; track $index) {
                <li class="link" (click)="onResponseLinkClick(link)">
                  {{ link.title }}
                </li>
              }
            </ul>
          </div>
        }
        @if (message.allowFeedback) {
          <div class="d-flex justify-content-end">
            <kehe-phoenix-button
              classAttr="btn-default btn-icon-only"
              (click)="providePositiveFeedback(message.systemMessageId)"
            >
              <i class="fa-regular fa-thumbs-up" style="font-size: 1rem"></i>
            </kehe-phoenix-button>
            <kehe-phoenix-button
              class="ms-2"
              classAttr="btn-default btn-icon-only"
              (click)="provideNegativeFeedback(message.systemMessageId)"
            >
              <i class="fa-regular fa-thumbs-down" style="font-size: 1rem"></i>
            </kehe-phoenix-button>
          </div>
        }
      </ng-template>
    </kendo-chat>
  }
</ng-template>

<ng-template #chatFooterTemplate>
  <div class="chatbot-disclaimer">
    This content has been generated by an artificial intelligence language
    model. While KeHE strives for accuracy and quality, please note that the
    information provided may not be error-free or completely up-to-date. KeHE
    recommends Suppliers independently verify the content and consult with their
    KeHE representatives for clarification and additional information. KeHE does
    not assume any liability for the use or interpretation of this content.
  </div>
</ng-template>

<kendo-floatingactionbutton
  kendoPopoverAnchor
  showOn="none"
  #anchor="kendoPopoverAnchor"
  [popover]="chatPopover"
  (click)="toggle(anchor)"
  class="chat-bot-floating-action-button"
  size="none"
>
  <ng-template kendoFloatingActionButtonTemplate>
    <kendo-avatar
      size="medium"
      imageSrc="https://kehe-connect.s3.amazonaws.com/prod/public_common/chat-icon.png"
      class="chat-bot-avatar"
    ></kendo-avatar
    >Ask Goodness Guru™
  </ng-template>
</kendo-floatingactionbutton>

<kendo-popover
  #chatPopover
  position="top"
  [callout]="false"
  [animation]="{ type: 'expand', direction: 'up', duration: '400' }"
  (shown)="onPopoverShown()"
  (hidden)="onPopoverHidden()"
>
  <ng-template kendoPopoverTitleTemplate>
    <ng-template [ngTemplateOutlet]="chatTitleTemplate"></ng-template>
  </ng-template>
  <ng-template kendoPopoverBodyTemplate>
    <ng-template [ngTemplateOutlet]="chatBodyTemplate"></ng-template>
  </ng-template>
  <ng-template kendoPopoverActionsTemplate>
    <ng-template [ngTemplateOutlet]="chatFooterTemplate"></ng-template>
  </ng-template>
</kendo-popover>

@if (modalOpen) {
  <kehe-phoenix-modal [show]="true" (modalEvent)="toggle()" [size]="'fs'">
    <div header>
      <ng-template [ngTemplateOutlet]="chatTitleTemplate"></ng-template>
    </div>
    <div body>
      <ng-template [ngTemplateOutlet]="chatBodyTemplate"></ng-template>
    </div>
    <div footer>
      <ng-template [ngTemplateOutlet]="chatFooterTemplate"></ng-template>
    </div>
  </kehe-phoenix-modal>
}
